import soilDataConfigApi from '@/api/config/soilDataConfigApi'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { NotifyService } from '@/helpers'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function deleteSoil(interfaceId: string, id: string): Promise<void> {
  await soilDataConfigApi.delete(interfaceId, id)
}

function useDeleteSoil() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: any) => deleteSoil(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.soil])
        toast.success(t('deleteSoilSuccessfully'))
        closeModal()
      },
      onError: (error: any) => {
        NotifyService.error(error)
        closeModal()
      },
    },
  )

  // return mutate
}

export default useDeleteSoil
